import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const referenceYearServiceUrl = `${API_URL}/refYear`;

const getReferenceYearsByLaboratoryIdAndProgramId = (laboratoryId, programId) =>
  RequestHelper.GET(`${referenceYearServiceUrl}/${laboratoryId}/${programId}/refYears`);

export const ReferenceYearService = {
  getReferenceYearsByLaboratoryIdAndProgramId
};